import React, { useState } from 'react'
import BuddyLoanReport from './BuddyLoanReport.container'
import BranchReport from './BranchData.container'
import { ROLE } from '../../../../utils/Constant'
import BackLogo from '../../../../images/rewampimages/Chevron.png'
export default function BranchBuddyLoanMain({ admin, pageViewHandler }) {
    const [viewState, setViewState] = useState('branch')
    return (
        <>
            <div className='marketing-main-css'>
                <div className="row fixed-top">
                    {
                        admin.rolelist.indexOf(ROLE.Generate_Buddy_Loan_Report) >= 0 ?
                            <div className={`${admin.rolelist.indexOf(ROLE.Generate_Buddy_Loan_Report) >= 0 ? "col-sm-6 col-xs-6" : 'col-xs-12'} expenseTabs ${viewState == "branch" ? "active" : "customBorderBottom" }`} onClick={() => setViewState('branch')} style={{ textAlign: 'center' ,width:'50%'}}>
                                Branch Report
                            </div>
                            : ''}
                    {admin.rolelist.indexOf(ROLE.Generate_Buddy_Loan_Report) >= 0 ?
                        <div className={`${admin.rolelist.indexOf(ROLE.Generate_Buddy_Loan_Report) >= 0 ? "col-sm-6 col-xs-6" : 'col-xs-12'} expenseTabs ${viewState == "buddy" ? "active" : "customBorderBottom" }`} onClick={() => setViewState('buddy')} style={{ textAlign: 'center',width:'50%'}}>
                            Buddy Loan Report

                        </div>
                        : ''}

                </div>
                <div className="container-fluid">
                <div className="row details-new-tab-div" >
                    <div className="col-sm-4 " style={{ marginTop: window.innerWidth > 1800 ? '0%' : '5%' }}>
                        <img onClick={(e) => pageViewHandler(e, 'landingPage')} style={{ cursor: 'pointer' }} src={BackLogo} width={'30px'} /> <button style={{ color: '#1D3557', fontWeight: '700' }} onClick={(e) => pageViewHandler(e, 'landingPage')} >Back</button>
                    </div>
                </div>
                </div>
                <div className="full-height" style={{ marginTop: window.innerWidth < 1800 ? '20px' : '' }}>
                    {viewState === 'branch' ?
                        <BranchReport />
                        : ""}
                    {viewState === 'buddy' ?
                        <BuddyLoanReport />
                        : ""}
                </div>
            </div>
        </>
    )
}
